/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const customStyles = {
  placeholder: (base) => ({
    ...base,
    fontSize: '16px',
    fontFamily: 'Gibson',
    fontWeight: 400,
    fontStyle: 'normal',
    marginLeft: '2px',
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: '16px',
    fontFamily: 'Gibson',
    fontWeight: 400,
    fontStyle: 'normal',
    marginLeft: '2px',
  }),
  container: (base) => ({
    ...base,
    marginLeft: '20px',
    marginRight: '15px',
    border: '1px solid #E7E7E7',
    borderRadius: '4px',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: 'white',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999, base }),
}
